// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"df1a064f","418":"964ea281","480":"fa8c285d"}[chunkId] + ".js";
};